export default {
  DEFAULT_ICON: 'panorama_fish_eye',

  MSISDN_CONFIG_CHANGE: { label: 'RECORDS_LIST.STATUS.MSISDN_CONFIG_CHANGE', properties: ['oldMsisdn', 'newMsisdn'] },
  SCHEDULE: {
    label: 'RECORDS_LIST.STATUS.SCHEDULE',
    properties: ['answerResults', 'callLength', 'clientMsisdn', 'name']
  },
  SUCCESS: {
    label: 'RECORDS_LIST.STATUS.SUCCESS',
    icon: 'check_circle',
    properties: ['answerResults', 'callLength', 'clientMsisdn', 'name']
  },
  REFUSE: { label: 'RECORDS_LIST.STATUS.REFUSE', properties: ['answerResults', 'callLength', 'clientMsisdn', 'name'] },
  FAILED_CONTACT: { label: 'RECORDS_LIST.STATUS.FAILED_CONTACT' },
  NOT_VERIFIED: { label: 'RECORDS_LIST.STATUS.NOT_VERIFIED' },
  NOTE: { label: 'RECORDS_LIST.STATUS.NOTE', properties: ['note'] },
  INCOMING_CALL_ANSWERED: { label: 'RECORDS_LIST.STATUS.INCOMING_CALL_ANSWERED' },
  INCOMING_CALL_REDIRECTED: { label: 'RECORDS_LIST.STATUS.INCOMING_CALL_REDIRECTED' },
  CONFERENCE_CALL: {
    label: 'RECORDS_LIST.STATUS.CONFERENCE_CALL',
    newMsisdnTranslation: 'RECORDS_LIST.TRANSFER_NUMBER'
  },
  TRANSFER_CALL: { label: 'RECORDS_LIST.STATUS.TRANSFER_CALL', newMsisdnTranslation: 'RECORDS_LIST.TRANSFER_NUMBER' },
  IMPORT_CONTACT: { label: 'RECORDS_LIST.STATUS.IMPORT_CONTACT' },
  OPEN_CONTACT: { label: 'RECORDS_LIST.STATUS.OPEN_CONTACT' },
  VOICE_MAIL_DROP: { label: 'RECORDS_LIST.STATUS.VOICE_MAIL_DROP' },
  CONTACT_DETAILS_CHANGE: { label: 'RECORDS_LIST.STATUS.CONTACT_DETAILS_CHANGE' },

  AUTOSCHEDULED: { label: 'RECORDS_LIST.STATUS.AUTOSCHEDULED' },
  CLOSED: { label: 'RECORDS_LIST.STATUS.CLOSED' },
  OPEN: { label: 'RECORDS_LIST.STATUS.OPEN' },
  SCHEDULED: { label: 'RECORDS_LIST.STATUS.SCHEDULED' },
  ADD_MSISDN: { label: 'RECORDS_LIST.STATUS.ADD_MSISDN' },
  RESCHEDULE_FOR_NOW: { label: 'RECORDS_LIST.STATUS.RESCHEDULE_FOR_NOW' },
  CLOSE_CONTACT: { label: 'RECORDS_LIST.STATUS.CLOSE_CONTACT' },
  EMAIL_CONFIG_CHANGE: { label: 'RECORDS_LIST.STATUS.EMAIL_CONFIG_CHANGE' },
  INDECISIVE_PERSON: { label: 'RECORDS_LIST.STATUS.INDECISIVE_PERSON' },
  EMAIL: { label: 'RECORDS_LIST.STATUS.EMAIL' },

  VOICE_MAIL: { label: 'SYSTEM_EVENTS.VOICE_MAIL' },
  BUSY: { label: 'SYSTEM_EVENTS.BUSY' },
  NOT_ANSWERED: { label: 'SYSTEM_EVENTS.NOT_ANSWERED' },
  UNAVAILABLE_MSISDN: { label: 'SYSTEM_EVENTS.UNAVAILABLE_MSISDN' },
  NETWORK_ERROR: { label: 'SYSTEM_EVENTS.NETWORK_ERROR' },
  REDIRECT_INCOMING_CALL: { label: 'SYSTEM_EVENTS.REDIRECT_INCOMING_CALL' },
  INCOMING_CALL: { label: 'SYSTEM_EVENTS.INCOMING_CALL' },
  NO_MSISDN_TO_CALL: { label: 'SYSTEM_EVENTS.NO_MSISDN_TO_CALL' },
  FAILED_CONNECT_AGENT: { label: 'SYSTEM_EVENTS.FAILED_CONNECT_AGENT' },
  INSUFFICIENT_FUNDS: { label: 'SYSTEM_EVENTS.INSUFFICIENT_FUNDS' },
  INCOMING_CALL_NOT_ANSWERED: { label: 'SYSTEM_EVENTS.INCOMING_CALL_NOT_ANSWERED', class: 'missed-call' },
  INCOMING_CALL_VOICEMAIL: { label: 'SYSTEM_EVENTS.INCOMING_CALL_NOT_ANSWERED_VOICEMAIL', icon: 'voicemail' }
};
